import { UserInfo } from "../../domain/model/user-info";
import { StoreAnimalWeighingSaveInfo } from "../../storage/data-store/model/store-animal-weighing-save-info";
import { StoreUpdateInfo } from "../../storage/store-update-info";
import { AnimalWeighingSaveInfoViewModel } from "../../viewmodels/shared/animal-weighing-save-info.viewmodel";
import { UpdateInfoViewModel } from "../../viewmodels/shared/update.viewmodel";
import { UserInfoViewModel } from "../../viewmodels/shared/user-info.viewmodel";

export function mapToStoreUserInfo(user: UserInfoViewModel): UserInfo {
  return new UserInfo(user.userId, user.name);
}

export function mapToStoreUpdateInfo(updateInfo: UpdateInfoViewModel): StoreUpdateInfo {
  return new StoreUpdateInfo(
    updateInfo.lastServerUpdate,
    updateInfo.lastLocalUpdate,
    updateInfo.lastEditedByUser !== null ?
      mapToStoreUserInfo(updateInfo.lastEditedByUser) :
      null);
}

export function mapToStoreAnimalWeighingSaveInfo(
  animalWeighingSaveInfos: AnimalWeighingSaveInfoViewModel[]
): StoreAnimalWeighingSaveInfo[] {
  const storeAnimalWeighingSaveInfos = animalWeighingSaveInfos.map(
    (animalWeighingSaveInfo) => {
    return new StoreAnimalWeighingSaveInfo(
      animalWeighingSaveInfo.id,
      animalWeighingSaveInfo.batchWeighingId,
      animalWeighingSaveInfo.animalWeights,
      mapToStoreUpdateInfo(animalWeighingSaveInfo.updateInfo)
    )}
  );
    return storeAnimalWeighingSaveInfos;
}
